import { createReactPlayer } from './ReactPlayer.js'
import Player from './players/FilePlayer.js'
export default createReactPlayer([{
  key: 'file',
  canPlay: Player.canPlay,
  lazyPlayer: Player
}])
